// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1HtzP","row":"Node_row__2zQ96","label":"Node_label__2wAwh","footer":"Node_footer__187-c"};